import { unificar_aluno } from "./unificar-aluno";

const unificacao_aluno = [unificar_aluno];

export { unificacao_aluno };
